import { type FC, type SVGProps } from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="#141414"
      d="M17.9689 9.45898L9.53589 2.13979C9.47116 2.08398 9.38857 2.05273 9.30152 2.05273H7.32607C7.16089 2.05273 7.085 2.25809 7.21 2.36523L15.027 9.15095H1.96446C1.86625 9.15095 1.78589 9.23131 1.78589 9.32952V10.6688C1.78589 10.767 1.86625 10.8474 1.96446 10.8474H15.0247L7.20776 17.6331C7.08276 17.7425 7.15866 17.9456 7.32384 17.9456H9.36625C9.40866 17.9456 9.45107 17.93 9.48232 17.901L17.9689 10.5393C18.0462 10.4721 18.1082 10.3892 18.1506 10.296C18.1931 10.2028 18.215 10.1016 18.215 9.99916C18.215 9.89676 18.1931 9.79555 18.1506 9.70236C18.1082 9.60917 18.0462 9.52618 17.9689 9.45898Z"
    />
  </svg>
);
